import { render, staticRenderFns } from "./AlternateCompareStep.vue?vue&type=template&id=16e85bf0"
import script from "./AlternateCompareStep.ts?vue&type=script&lang=ts&external"
export * from "./AlternateCompareStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e85bf0')) {
      api.createRecord('16e85bf0', component.options)
    } else {
      api.reload('16e85bf0', component.options)
    }
    module.hot.accept("./AlternateCompareStep.vue?vue&type=template&id=16e85bf0", function () {
      api.rerender('16e85bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/AlternateCompareStep.vue"
export default component.exports